import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Separator } from '@/components/ui/separator';
import { LogOut, ShieldCheck } from 'lucide-react';
import { useUserMenu } from './use-user-menu';

export function UserMenu() {
  const f = useUserMenu();

  if (!f.shouldShow) return null;

  return (
    <>
      <Dialog open={f.accountDialogOpen} onOpenChange={f.setAccountDialogOpen}>
        <DialogTrigger asChild>
          <Button variant="ghost" size="icon" className="rounded-full">
            <Avatar className="h-8 w-8">
              <AvatarImage src={f.photoURL} alt={f.photoAlt} />
              <AvatarFallback>{f.initials}</AvatarFallback>
            </Avatar>
          </Button>
        </DialogTrigger>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Account</DialogTitle>
            <DialogDescription>Manage your account settings and preferences</DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="flex items-center gap-4">
              <Avatar className="h-16 w-16">
                <AvatarImage src={f.photoURL} alt={f.photoAlt} />
                <AvatarFallback className="text-xl">{f.initials}</AvatarFallback>
              </Avatar>
              <div className="flex-1">
                <p className="font-medium text-foreground">{f.displayName}</p>
                <p className="text-sm text-muted-foreground">{f.email}</p>
              </div>
            </div>
            <Separator />
            <div className="space-y-2">
              <Button onClick={f.handleSignOut} variant="outline" className="w-full">
                <LogOut className="h-4 w-4" />
                Sign Out
              </Button>
              <Button onClick={f.openConfirmDialog} variant="destructive" className="w-full">
                <ShieldCheck className="h-4 w-4" />
                Disconnect & Sign Out
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog open={f.confirmDialogOpen} onOpenChange={f.setConfirmDialogOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Disconnect & Sign Out?</DialogTitle>
            <DialogDescription>
              This removes stored Google Cloud credentials, clears the active Firestore selection,
              and clears saved explorer state on this browser. Your Emberdesk account and retained
              usage or billing records are not deleted.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={f.closeConfirmDialog} disabled={f.isLoggingOut}>
              Cancel
            </Button>
            <Button
              variant="destructive"
              onClick={f.handleLogoutAndForget}
              disabled={f.isLoggingOut}
            >
              {f.isLoggingOut ? 'Disconnecting...' : 'Disconnect & Sign Out'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
